// import React, { useCallback, useEffect, useState } from "react";
// import axios from "axios";
// import MastiStatsAndFilter from "./components/MastiStatsAndFilter";
// import MastiTable from "./components/MastiTable";

// const BASE_URL = process.env.REACT_APP_API_URL;
// const LIMIT = 5;

// export const MastiScreen = () => {
//   const [data, setData] = useState([]);
//   const [stats, setStats] = useState({ pending: 0, approved: 0, rejected: 0 });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [search, setSearch] = useState("");
//   const [typeFilter, setTypeFilter] = useState("All");
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const fetchMastis = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const params = {
//         page: currentPage,
//         limit: LIMIT,
//         ...(search && { search }),
//         ...(typeFilter !== "All" && { type: typeFilter }),
//         ...(statusFilter !== "All" && { status: statusFilter }),
//       };
//       const { data: res } = await axios.get(`${BASE_URL}/masti/get-all`, {
//         params,
//       });
//       setData(res.data);
//       setTotalPages(res.totalPages ?? 1);
//     } catch (err) {
//       setError(err?.response?.data?.message || "Failed to fetch masti list.");
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, search, typeFilter, statusFilter]);

//   const fetchStats = useCallback(async () => {
//     try {
//       const { data: res } = await axios.get(`${BASE_URL}/masti/stats`);
//       if (res.success) setStats(res.data);
//     } catch {
//       // stats are non-critical
//     }
//   }, []);

//   useEffect(() => {
//     fetchMastis();
//   }, [fetchMastis]);
//   useEffect(() => {
//     fetchStats();
//   }, [fetchStats]);

//   // Reset to page 1 on filter/search change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, typeFilter, statusFilter]);

//   const handleActionSuccess = () => {
//     fetchMastis();
//     fetchStats();
//   };

//   return (
//     <div className="min-h-screen bg-pink-50/30 py-6">
//       <div className="mx-auto max-w-7xl">
//         <MastiStatsAndFilter
//           stats={stats}
//           search={search}
//           onSearchChange={setSearch}
//           typeFilter={typeFilter}
//           onTypeFilterChange={setTypeFilter}
//           statusFilter={statusFilter}
//           onStatusFilterChange={setStatusFilter}
//         />
//         <MastiTable
//           data={data}
//           loading={loading}
//           error={error}
//           currentPage={currentPage}
//           limit={LIMIT}
//           totalPages={totalPages}
//           onPageChange={setCurrentPage}
//           onActionSuccess={handleActionSuccess}
//           canEdit={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default MastiScreen;

// ===============================
// UPDATED MastiScreen.jsx
// ===============================

import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import MastiStatsAndFilter from "./components/MastiStatsAndFilter";
import MastiTable from "./components/MastiTable";

import MastiCategoryTable from "./components/MastiCategoryTable";
import AddEditMastiCategoryModal from "./components/AddEditMastiCategoryModal";

const BASE_URL = process.env.REACT_APP_API_URL;
const LIMIT = 5;

export const MastiScreen = () => {
  const [activeTab, setActiveTab] = useState("gang-request");

  // =========================
  // GANG REQUEST STATES
  // =========================
  const [data, setData] = useState([]);
  const [stats, setStats] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // =========================
  // CATEGORY STATES
  // =========================
  const [categories, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // =========================
  // FETCH MASTI REQUESTS
  // =========================
  const fetchMastis = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const params = {
        page: currentPage,
        limit: LIMIT,
        ...(search && { search }),
        ...(typeFilter !== "All" && { type: typeFilter }),
        ...(statusFilter !== "All" &&
          statusFilter !== "Live" && {
            status: statusFilter,
          }),
        ...(statusFilter === "Live" && { isLive: true }),
      };

      const { data: res } = await axios.get(`${BASE_URL}/masti/get-all`, {
        params,
      });

      setData(res.data);
      setTotalPages(res.totalPages ?? 1);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to fetch masti list.");
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, typeFilter, statusFilter]);

  // =========================
  // FETCH STATS
  // =========================
  const fetchStats = useCallback(async () => {
    try {
      const { data: res } = await axios.get(`${BASE_URL}/masti/stats`);

      if (res.success) {
        setStats(res.data);
      }
    } catch (error) {}
  }, []);

  // =========================
  // FETCH CATEGORIES
  // =========================
  const fetchCategories = useCallback(async () => {
    try {
      setCategoryLoading(true);

      const { data: res } = await axios.get(
        `${BASE_URL}/masti-categories/get-all`
      );

      setCategories(res.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setCategoryLoading(false);
    }
  }, []);

  const makeMastiOffline = useCallback(async (mastiId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/masti/make-offline/${mastiId}`
      );
      console.log("response of makeMastiOffline-------->", response.data);
      fetchMastis();
    } catch (error) {
      console.log("Error in makeMastiOffline: ", error);
    }
  });

  // =========================
  // EFFECTS
  // =========================
  useEffect(() => {
    if (activeTab === "gang-request") {
      fetchMastis();
      fetchStats();
    }
  }, [activeTab, fetchMastis, fetchStats]);

  useEffect(() => {
    if (activeTab === "masti-category") {
      fetchCategories();
    }
  }, [activeTab, fetchCategories]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, typeFilter, statusFilter]);

  // =========================
  // CATEGORY ACTIONS
  // =========================
  const handleAddCategory = () => {
    setSelectedCategory(null);
    setOpenModal(true);
  };

  const handleEditCategory = (category) => {
    setSelectedCategory(category);
    setOpenModal(true);
  };

  const handleDeleteCategory = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );

    if (!confirmDelete) return;

    try {
      await axios.delete(`${BASE_URL}/masti-categories/delete/${id}`);

      fetchCategories();
    } catch (error) {
      console.log(error);
    }
  };

  const handleActionSuccess = () => {
    fetchMastis();
    fetchStats();
  };

  return (
    <div className="min-h-screen bg-pink-50/30 py-6">
      <div className="mx-auto max-w-7xl">
        {/* ========================= */}
        {/* TABS */}
        {/* ========================= */}
        <div className="mb-6 flex items-center gap-4 border-b border-gray-200">
          <button
            onClick={() => setActiveTab("gang-request")}
            className={`border-b-2 px-4 py-3 text-sm font-semibold transition-all ${
              activeTab === "gang-request"
                ? "border-pink-500 text-pink-600"
                : "border-transparent text-gray-500"
            }`}
          >
            Masti Request
          </button>

          <button
            onClick={() => setActiveTab("masti-category")}
            className={`border-b-2 px-4 py-3 text-sm font-semibold transition-all ${
              activeTab === "masti-category"
                ? "border-pink-500 text-pink-600"
                : "border-transparent text-gray-500"
            }`}
          >
            Masti Category
          </button>
        </div>

        {/* ========================= */}
        {/* GANG REQUEST TAB */}
        {/* ========================= */}
        {activeTab === "gang-request" && (
          <>
            <MastiStatsAndFilter
              stats={stats}
              search={search}
              onSearchChange={setSearch}
              typeFilter={typeFilter}
              onTypeFilterChange={setTypeFilter}
              statusFilter={statusFilter}
              onStatusFilterChange={setStatusFilter}
            />

            <MastiTable
              data={data}
              loading={loading}
              error={error}
              currentPage={currentPage}
              limit={LIMIT}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              onActionSuccess={handleActionSuccess}
              canEdit={true}
              statusFilter={statusFilter}
              makeMastiOffline={makeMastiOffline}
            />
          </>
        )}

        {/* ========================= */}
        {/* CATEGORY TAB */}
        {/* ========================= */}
        {activeTab === "masti-category" && (
          <>
            <div className="mb-5 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">
                Masti Categories
              </h2>

              <button
                onClick={handleAddCategory}
                className="rounded-lg bg-pink-500 px-5 py-2 text-sm font-medium text-white hover:bg-pink-600"
              >
                Add Category
              </button>
            </div>

            <MastiCategoryTable
              categories={categories}
              loading={categoryLoading}
              onEdit={handleEditCategory}
              onDelete={handleDeleteCategory}
            />
          </>
        )}
      </div>

      {/* ========================= */}
      {/* MODAL */}
      {/* ========================= */}
      <AddEditMastiCategoryModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        category={selectedCategory}
        onSuccess={fetchCategories}
      />
    </div>
  );
};

export default MastiScreen;
